import http from '../../http'
export default {
  list: (params) => {
    return http.post('formbuilder/filemanager/page', params)
  },
  add: (params) => {
    return http.post('formbuilder/filemanager/save', params)
  },
  del: (params) => {
    return http.post('formbuilder/filemanager/delete', params)
  },
  get: (params) => {
    return http.post('formbuilder/filemanager/get', params)
  },
  updateCount: (params) => {
    return http.post('formbuilder/filemanager/savecount', params)
  },
  updateRange: (params) => {
    return http.get('formbuilder/filemanager/update/range', params)
  }
}
